import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "account-settings-modal" }
const _hoisted_2 = { class: "settings-tabs" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "Welcome-username" }
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "Free-account" }, "Free account", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:support@tawa.digital",
  class: "upgrade-now"
}, "upgrade now", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "settings-avatar flex-cl" }
const _hoisted_12 = { class: "img-wrapper" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = {
  key: 2,
  class: "error-text"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = { class: "tabs-content" }
const _hoisted_17 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_18 = {
  key: 1,
  class: "form-container"
}
const _hoisted_19 = {
  key: 0,
  class: "alert alert-info submitMsg"
}
const _hoisted_20 = { class: "" }
const _hoisted_21 = {
  key: 0,
  action: ""
}
const _hoisted_22 = { class: "d-flex mb-3 form-row" }
const _hoisted_23 = { class: "d-flex flex-column align-items-start w-50" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "fullname",
  "aria-readonly": "true",
  class: "label"
}, "Brand name*", -1)
const _hoisted_25 = {
  key: 0,
  class: "error-text"
}
const _hoisted_26 = { class: "d-flex flex-column align-items-start w-50" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "first_name",
  class: "label"
}, "First name*", -1)
const _hoisted_28 = {
  key: 0,
  class: "error-text"
}
const _hoisted_29 = { class: "d-flex mb-3 form-row" }
const _hoisted_30 = { class: "d-flex flex-column align-items-start w-50 m-0" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "last_name",
  class: "label"
}, "Last name*", -1)
const _hoisted_32 = {
  key: 0,
  class: "error-text"
}
const _hoisted_33 = { class: "d-flex flex-column align-items-start w-50" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "email_address",
  "aria-readonly": "true",
  class: "label"
}, "Email address*", -1)
const _hoisted_35 = { class: "d-flex mb-3 form-row" }
const _hoisted_36 = { class: "d-flex align-items-start w-50 m-0 settings-phone-container" }
const _hoisted_37 = { class: "d-flex flex-column align-items-start w-38 m-0" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone_prefix",
  class: "label"
}, "Phone prefix*", -1)
const _hoisted_39 = {
  key: 0,
  class: "error-text"
}
const _hoisted_40 = { class: "phone-wrapper" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone_number",
  class: "label"
}, "Phone number*", -1)
const _hoisted_42 = {
  key: 0,
  class: "error-text"
}
const _hoisted_43 = { class: "d-flex flex-column align-items-start w-50 account-setting-modal-multiselect-input" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "buisness_sector",
  class: "label"
}, "Buisness sector*", -1)
const _hoisted_45 = {
  key: 0,
  class: "error-text"
}
const _hoisted_46 = { class: "d-flex mb-3 form-row" }
const _hoisted_47 = { class: "d-flex flex-column align-items-start w-50 account-setting-modal-multiselect-input" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  for: "residence",
  class: "label"
}, "Country*", -1)
const _hoisted_49 = {
  key: 0,
  class: "error-text"
}
const _hoisted_50 = {
  key: 0,
  class: "d-flex flex-column align-items-start w-50 m-0 account-setting-modal-multiselect-input"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "label"
}, "Cities*", -1)
const _hoisted_52 = {
  key: 0,
  class: "error-text"
}
const _hoisted_53 = { class: "d-flex mb-3 form-row" }
const _hoisted_54 = { class: "d-flex flex-column align-items-start w-50 m-0" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", {
  for: "ig_username",
  class: "label"
}, "Instagram username/Link", -1)
const _hoisted_56 = ["readonly"]
const _hoisted_57 = {
  key: 0,
  class: "error-text"
}
const _hoisted_58 = { class: "d-flex flex-column align-items-start w-50 m-0" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", {
  for: "tiktok_username",
  class: "label"
}, "Tiktok username/Link", -1)
const _hoisted_60 = ["readonly"]
const _hoisted_61 = {
  key: 0,
  class: "error-text"
}
const _hoisted_62 = { class: "d-flex mb-3 form-row" }
const _hoisted_63 = { class: "d-flex flex-column align-items-start w-50 m-0" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", {
  for: "website_url",
  class: "label"
}, "Website url", -1)
const _hoisted_65 = {
  key: 1,
  action: ""
}
const _hoisted_66 = { class: "d-flex mb-3 form-row" }
const _hoisted_67 = { class: "d-flex flex-column align-items-start w-50 m-0" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", {
  for: "first_name",
  class: "label"
}, "First name*", -1)
const _hoisted_69 = {
  key: 0,
  class: "error-text"
}
const _hoisted_70 = { class: "d-flex flex-column align-items-start w-50" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", {
  for: "last_name",
  class: "label"
}, "last name*", -1)
const _hoisted_72 = {
  key: 0,
  class: "error-text"
}
const _hoisted_73 = { class: "d-flex mb-3 form-row" }
const _hoisted_74 = { class: "d-flex align-items-start w-50 m-0 settings-phone-container" }
const _hoisted_75 = { class: "d-flex flex-column align-items-start w-38 m-0" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone_prefix",
  class: "label"
}, "Phone prefix*", -1)
const _hoisted_77 = {
  key: 0,
  class: "error-text"
}
const _hoisted_78 = { class: "phone-wrapper" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone_number",
  class: "label"
}, "Phone number*", -1)
const _hoisted_80 = {
  key: 0,
  class: "error-text"
}
const _hoisted_81 = { class: "d-flex flex-column align-items-start w-50 m-0" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "label"
}, "Email address", -1)
const _hoisted_83 = { class: "d-flex mb-3 form-row" }
const _hoisted_84 = { class: "d-flex flex-column align-items-start w-50 account-setting-modal-multiselect-input" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", {
  for: "gender",
  class: "label"
}, "Gender*", -1)
const _hoisted_86 = {
  key: 0,
  class: "error-text"
}
const _hoisted_87 = { class: "d-flex flex-column align-items-start w-50 m-0 account-setting-modal-multiselect-input" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", {
  for: "age",
  class: "label"
}, "Age range*", -1)
const _hoisted_89 = {
  key: 0,
  class: "error-text"
}
const _hoisted_90 = { class: "d-flex mb-3 form-row" }
const _hoisted_91 = { class: "d-flex flex-column align-items-start w-50 account-setting-modal-multiselect-input" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", {
  for: "residence",
  class: "label"
}, "Country*", -1)
const _hoisted_93 = {
  key: 0,
  class: "error-text"
}
const _hoisted_94 = { class: "d-flex flex-column align-items-start w-50 m-0 account-setting-modal-multiselect-input" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", {
  for: "influencer-city",
  class: "label"
}, "City*", -1)
const _hoisted_96 = {
  key: 0,
  class: "error-text"
}
const _hoisted_97 = { class: "d-flex mb-3 form-row" }
const _hoisted_98 = { class: "d-flex flex-column align-items-start w-50" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", {
  for: "instagram",
  class: "label d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-instagram me-2" }),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Instagram "),
    /*#__PURE__*/_createElementVNode("a", { href: "" }),
    /*#__PURE__*/_createTextVNode("account*")
  ])
], -1)
const _hoisted_100 = ["readonly"]
const _hoisted_101 = {
  key: 0,
  class: "error-text"
}
const _hoisted_102 = { class: "d-flex flex-column align-items-start w-50" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", {
  for: "tiktok",
  class: "label d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-tiktok me-2" }),
  /*#__PURE__*/_createElementVNode("span", null, "Tiktok account*")
], -1)
const _hoisted_104 = ["readonly"]
const _hoisted_105 = {
  key: 0,
  class: "error-text"
}
const _hoisted_106 = { class: "d-flex mb-3 w-100" }
const _hoisted_107 = { class: "d-flex flex-column align-items-start w-95 m-0" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", {
  for: "category",
  class: "label mb-1"
}, "Categories*", -1)
const _hoisted_109 = {
  key: 0,
  class: "error-text"
}
const _hoisted_110 = { class: "d-flex mb-3" }
const _hoisted_111 = { class: "d-flex flex-column align-items-start w-95 m-0" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", {
  for: "bio",
  class: "label mb-1"
}, "Bio", -1)
const _hoisted_113 = {
  key: 2,
  class: "alert alert-success text-center successMsg"
}
const _hoisted_114 = {
  key: 3,
  class: "alert alert-danger text-center successMsg"
}
const _hoisted_115 = ["disabled"]
const _hoisted_116 = {
  key: 2,
  class: "form-container"
}
const _hoisted_117 = {
  key: 0,
  class: "alert alert-info w-100 text-center"
}
const _hoisted_118 = { class: "" }
const _hoisted_119 = { class: "d-flex mb-3" }
const _hoisted_120 = { class: "form-group" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "label"
}, "Your password", -1)
const _hoisted_122 = { class: "input-field" }
const _hoisted_123 = {
  key: 0,
  class: "input-field flex-column w-100"
}
const _hoisted_124 = {
  key: 0,
  class: "error-text"
}
const _hoisted_125 = {
  key: 1,
  class: "input-field flex-column w-100"
}
const _hoisted_126 = {
  key: 0,
  class: "error-text"
}
const _hoisted_127 = { class: "d-flex mb-3" }
const _hoisted_128 = { class: "form-group" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", {
  for: "new_password",
  class: "label"
}, "New password", -1)
const _hoisted_130 = { class: "input-field" }
const _hoisted_131 = { class: "input-field flex-column w-100" }
const _hoisted_132 = {
  key: 0,
  class: "error-text"
}
const _hoisted_133 = { class: "d-flex mb-3" }
const _hoisted_134 = { class: "form-group" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirm_password",
  class: "label"
}, "Confirm new password", -1)
const _hoisted_136 = { class: "input-field" }
const _hoisted_137 = { class: "input-field flex-column w-100" }
const _hoisted_138 = {
  key: 0,
  class: "error-text"
}
const _hoisted_139 = {
  key: 0,
  class: "alert alert-success successMsg"
}
const _hoisted_140 = {
  key: 1,
  class: "alert alert-danger errorMsg"
}
const _hoisted_141 = { class: "actions-btns" }
const _hoisted_142 = ["disabled"]
const _hoisted_143 = {
  key: 3,
  class: "form-container"
}
const _hoisted_144 = {
  key: 0,
  class: "alert alert-info w-100 text-center"
}
const _hoisted_145 = { class: "" }
const _hoisted_146 = { class: "d-flex mb-3" }
const _hoisted_147 = { class: "flex-row space-between w-100 align-items-center" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("label", {
  for: "start",
  class: "notifications-preferences-label w-90"
}, " Receive instant notifications on collaboration activities, campaign progress, and important reminders. ", -1)
const _hoisted_149 = { class: "notifications-preferences-switch" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("span", { class: "notifications-preferences-slider round" }, null, -1)
const _hoisted_151 = { class: "d-flex mb-3" }
const _hoisted_152 = { class: "flex-row space-between w-100 align-items-center" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", {
  for: "start",
  class: "notifications-preferences-label w-90"
}, " Get timely notifications and updates delivered to your email inbox. ", -1)
const _hoisted_154 = { class: "notifications-preferences-switch" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("span", { class: "notifications-preferences-slider round" }, null, -1)
const _hoisted_156 = {
  key: 0,
  class: "alert alert-success successMsg"
}
const _hoisted_157 = {
  key: 1,
  class: "alert alert-danger errorMsg"
}
const _hoisted_158 = { class: "actions-btns" }
const _hoisted_159 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.activeTab === 'profile' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchTab('profile')))
      }, " Profile ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.activeTab === 'password' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTab('password')))
      }, " Password ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.activeTab === 'notifications-preferences' }),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchTab('notifications-preferences')))
      }, " Notifications preferences ", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, "Welcome " + _toDisplayString(_ctx.formData.fullname) + " 👋 ", 1),
        (_ctx.isValidated && _ctx.isAdvertiser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, [
            _createElementVNode("img", {
              class: "img-fluid",
              src: _ctx.thumbnail,
              alt: _ctx.formData.fullname || undefined
            }, null, 8, _hoisted_13)
          ]),
          (_ctx.isAdvertiser)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "file",
                accept: "image/*",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectFile($event))),
                class: _normalizeClass([{ 'invalid-field': _ctx.inf_errors?.profile_efile_id }, "master-btn btn bg-trans"])
              }, null, 34))
            : _createCommentVNode("", true),
          (!_ctx.isAdvertiser)
            ? (_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "file",
                accept: "image/*",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectFile($event))),
                class: _normalizeClass([{ 'invalid-field': _ctx.inf_errors?.profile_efile_id }, "master-btn-influencer bg-trans"]),
                width: "100%"
              }, null, 34))
            : _createCommentVNode("", true),
          (_ctx.inf_errors?.profile_efile_id && !_ctx.isAdvertiser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.inf_errors.profile_efile_id), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_15,
    _createElementVNode("div", _hoisted_16, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_Spinner)
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'profile')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_ctx.submitMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.submitMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.isAdvertiser)
                ? (_openBlock(), _createElementBlock("form", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          pattern: "",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.fullname) = $event)),
                          class: _normalizeClass(["input", { 'invalid-field': _ctx.adv_errors?.fullname }]),
                          id: "fullname",
                          onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateInput('fullname'))),
                          onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateInput('fullname'))),
                          readonly: ""
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.formData.fullname,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.adv_errors?.fullname)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.adv_errors.fullname), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.first_name) = $event)),
                          class: "input",
                          id: "first_name",
                          onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validateInput('first_name'))),
                          onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.validateInput('first_name')))
                        }, null, 544), [
                          [
                            _vModelText,
                            _ctx.formData.first_name,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.adv_errors?.first_name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.adv_errors.first_name), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.last_name) = $event)),
                          class: "input",
                          id: "last_name",
                          onKeyup: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validateInput('last_name'))),
                          onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validateInput('last_name')))
                        }, null, 544), [
                          [
                            _vModelText,
                            _ctx.formData.last_name,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.adv_errors?.last_name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.adv_errors.last_name), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          pattern: "",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.user_email) = $event)),
                          class: "input",
                          id: "email_address",
                          readonly: ""
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.formData.user_email,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.formData.phone_prefix,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.phone_prefix) = $event)),
                            value: _ctx.formData.phone_prefix,
                            mode: "single",
                            "close-on-select": true,
                            searchable: true,
                            "create-option": false,
                            options: _ctx.countries_prefixes,
                            placeholder: "Prefix",
                            class: _normalizeClass({ 'invalid-field': _ctx.adv_errors?.phone_prefix }),
                            onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.validateInput('phone_prefix')))
                          }, null, 8, ["modelValue", "value", "options", "class"]),
                          (_ctx.adv_errors?.phone_prefix)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.adv_errors?.phone_prefix), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            pattern: "",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.phone) = $event)),
                            class: _normalizeClass(["input", { 'invalid-field': _ctx.adv_errors?.phone }]),
                            id: "phone_number",
                            onKeyup: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validateInput('phone'))),
                            onBlur: _cache[19] || (_cache[19] = ($event: any) => (_ctx.validateInput('phone')))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.formData.phone,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.adv_errors?.phone)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.adv_errors?.phone), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode(_component_multiselect, {
                          id: "buisness_sector",
                          modelValue: _ctx.formData.business_sector_id,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.business_sector_id) = $event)),
                          value: _ctx.formData.business_sector_id,
                          options: _ctx.businessSectors,
                          mode: "single",
                          placeholder: "Choose your buisness sector",
                          class: _normalizeClass({ 'invalid-field': _ctx.adv_errors?.business_sector_id }),
                          onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.validateInput('business_sector_id')))
                        }, null, 8, ["modelValue", "value", "options", "class"]),
                        (_ctx.adv_errors?.business_sector_id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.adv_errors?.business_sector_id), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.formData.country,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.country) = $event)),
                          value: _ctx.formData.country,
                          mode: "single",
                          "close-on-select": true,
                          searchable: true,
                          "create-option": false,
                          options: _ctx.countries,
                          placeholder: "Choose your country",
                          class: _normalizeClass({ 'invalid-field': _ctx.adv_errors?.country }),
                          onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.validateInput('country')))
                        }, null, 8, ["modelValue", "value", "options", "class"]),
                        (_ctx.adv_errors?.country)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.adv_errors?.country), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.isAdvertiser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _hoisted_51,
                            _createVNode(_component_multiselect, {
                              id: "buisness_sector",
                              modelValue: _ctx.formData.cities,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.cities) = $event)),
                              value: _ctx.formData.cities,
                              options: _ctx.cities,
                              mode: "tags",
                              placeholder: "Choose your city/cities",
                              class: _normalizeClass({ 'invalid-field': _ctx.adv_errors?.cities }),
                              onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.validateInput('cities')))
                            }, null, 8, ["modelValue", "value", "options", "class"]),
                            (_ctx.adv_errors?.cities)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.adv_errors?.cities), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.ig_username) = $event)),
                          class: "input",
                          id: "ig_username",
                          onKeyup: _cache[27] || (_cache[27] = ($event: any) => (_ctx.validateInput('ig_username'))),
                          onBlur: _cache[28] || (_cache[28] = ($event: any) => (_ctx.validateInput('ig_username'))),
                          readonly: _ctx.is_ig_redonly
                        }, null, 40, _hoisted_56), [
                          [
                            _vModelText,
                            _ctx.formData.ig_username,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.adv_errors?.ig_username)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.adv_errors.ig_username), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.tiktok_username) = $event)),
                          class: "input",
                          id: "tiktok_username",
                          onKeyup: _cache[30] || (_cache[30] = ($event: any) => (_ctx.validateInput('tiktok_username'))),
                          onBlur: _cache[31] || (_cache[31] = ($event: any) => (_ctx.validateInput('tiktok_username'))),
                          readonly: _ctx.is_tk_redonly
                        }, null, 40, _hoisted_60), [
                          [
                            _vModelText,
                            _ctx.formData.tiktok_username,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.adv_errors?.tiktok_username)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.adv_errors.tiktok_username), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          pattern: "",
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.website_url) = $event)),
                          class: "input",
                          id: "website_url"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.formData.website_url,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("form", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _hoisted_68,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.first_name) = $event)),
                          class: _normalizeClass(["input", { 'invalid-field': _ctx.inf_errors?.first_name }]),
                          id: "first_name",
                          onKeyup: _cache[34] || (_cache[34] = ($event: any) => (_ctx.validateInput('first_name'))),
                          onBlur: _cache[35] || (_cache[35] = ($event: any) => (_ctx.validateInput('first_name')))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.formData.first_name,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.inf_errors?.first_name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.inf_errors.first_name), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _hoisted_71,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.last_name) = $event)),
                          class: _normalizeClass(["input", { 'invalid-field': _ctx.inf_errors?.last_name }]),
                          id: "last_name",
                          onKeyup: _cache[37] || (_cache[37] = ($event: any) => (_ctx.validateInput('last_name'))),
                          onBlur: _cache[38] || (_cache[38] = ($event: any) => (_ctx.validateInput('last_name')))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.formData.last_name,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.inf_errors?.last_name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.inf_errors.last_name), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _hoisted_76,
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.formData.phone_prefix,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.formData.phone_prefix) = $event)),
                            value: _ctx.formData.phone_prefix,
                            mode: "single",
                            "close-on-select": true,
                            searchable: true,
                            "create-option": false,
                            options: _ctx.countries_prefixes,
                            placeholder: "Prefix",
                            class: _normalizeClass({ 'invalid-field': _ctx.adv_errors?.phone_prefix }),
                            onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.validateInput('phone_prefix')))
                          }, null, 8, ["modelValue", "value", "options", "class"]),
                          (_ctx.adv_errors?.phone_prefix)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.adv_errors?.phone_prefix), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _hoisted_79,
                          _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            pattern: "",
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formData.phone) = $event)),
                            class: _normalizeClass(["input", { 'invalid-field': _ctx.adv_errors?.phone }]),
                            id: "phone_number",
                            onKeyup: _cache[42] || (_cache[42] = ($event: any) => (_ctx.validateInput('phone'))),
                            onBlur: _cache[43] || (_cache[43] = ($event: any) => (_ctx.validateInput('phone')))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.formData.phone,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.adv_errors?.phone)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.adv_errors?.phone), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _hoisted_82,
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.formData.user_email) = $event)),
                          class: "input w-90",
                          id: "email",
                          readonly: ""
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.formData.user_email,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _hoisted_85,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.formData.gender,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.formData.gender) = $event)),
                          value: _ctx.formData.gender,
                          mode: "single",
                          "close-on-select": true,
                          searchable: true,
                          "create-option": false,
                          options: _ctx.genders,
                          placeholder: "Choose your gender",
                          class: _normalizeClass({ 'invalid-field': _ctx.adv_errors?.gender }),
                          onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.validateInput('gender')))
                        }, null, 8, ["modelValue", "value", "options", "class"]),
                        (_ctx.adv_errors?.gender)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_ctx.adv_errors?.gender), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_87, [
                        _hoisted_88,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.formData.age_intervale,
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.formData.age_intervale) = $event)),
                          value: _ctx.formData.age_intervale,
                          mode: "single",
                          "close-on-select": true,
                          searchable: true,
                          "create-option": false,
                          options: [
                    { label: '18-25', value: '18-25' },
                    { label: '25-35', value: '25-35' },
                    { label: '35-45', value: '35-45' },
                    { label: '45 more', value: '45+' },
                  ],
                          placeholder: "Choose your age interval",
                          class: _normalizeClass({ 'invalid-field': _ctx.inf_errors?.age_intervale }),
                          onChange: _cache[48] || (_cache[48] = ($event: any) => (_ctx.validateInput('age_intervale')))
                        }, null, 8, ["modelValue", "value", "class"]),
                        (_ctx.inf_errors?.age_intervale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(_ctx.inf_errors.age_intervale), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _hoisted_92,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.formData.country,
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.formData.country) = $event)),
                          value: _ctx.formData.country,
                          mode: "single",
                          "close-on-select": true,
                          searchable: true,
                          "create-option": false,
                          options: _ctx.countries,
                          placeholder: "Choose your residence country",
                          class: _normalizeClass({ 'invalid-field': _ctx.inf_errors?.country }),
                          onChange: _cache[50] || (_cache[50] = ($event: any) => (_ctx.validateInput('country')))
                        }, null, 8, ["modelValue", "value", "options", "class"]),
                        (_ctx.inf_errors?.country)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.inf_errors.country), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _createVNode(_component_multiselect, {
                          id: "city",
                          modelValue: _ctx.formData.city,
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.formData.city) = $event)),
                          value: _ctx.formData.city,
                          options: _ctx.cities,
                          mode: "single",
                          placeholder: "Choose your city ",
                          class: _normalizeClass({ 'invalid-field': _ctx.inf_errors?.city }),
                          onChange: _cache[52] || (_cache[52] = ($event: any) => (_ctx.validateInput('city')))
                        }, null, 8, ["modelValue", "value", "options", "class"]),
                        (_ctx.inf_errors?.city)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_ctx.inf_errors.city), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, [
                        _hoisted_99,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.formData.ig_username) = $event)),
                          class: "input",
                          id: "instagram",
                          onKeyup: _cache[54] || (_cache[54] = ($event: any) => (_ctx.validateInput('ig_username'))),
                          onBlur: _cache[55] || (_cache[55] = ($event: any) => (_ctx.validateInput('ig_username'))),
                          readonly: _ctx.is_ig_redonly
                        }, null, 40, _hoisted_100), [
                          [
                            _vModelText,
                            _ctx.formData.ig_username,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.inf_errors?.username)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(_ctx.inf_errors.username), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _hoisted_103,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.formData.tiktok_username) = $event)),
                          class: "input",
                          id: "tiktok",
                          onKeyup: _cache[57] || (_cache[57] = ($event: any) => (_ctx.validateInput('tiktok_username'))),
                          onBlur: _cache[58] || (_cache[58] = ($event: any) => (_ctx.validateInput('tiktok_username'))),
                          readonly: _ctx.is_tk_redonly
                        }, null, 40, _hoisted_104), [
                          [
                            _vModelText,
                            _ctx.formData.tiktok_username,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.inf_errors?.username)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(_ctx.inf_errors.username), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _hoisted_108,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.formData.categories,
                          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.formData.categories) = $event)),
                          value: _ctx.formData.categories,
                          mode: "tags",
                          class: _normalizeClass(["input w-100", { 'invalid-field': _ctx.inf_errors?.categories }]),
                          "close-on-select": true,
                          searchable: true,
                          "create-option": false,
                          options: _ctx.categories,
                          placeholder: "Which categories do you are",
                          onChange: _cache[60] || (_cache[60] = ($event: any) => (_ctx.validateInput('categories')))
                        }, null, 8, ["modelValue", "value", "options", "class"]),
                        (_ctx.inf_errors?.categories)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(_ctx.inf_errors.categories), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("div", _hoisted_111, [
                        _hoisted_112,
                        _withDirectives(_createElementVNode("textarea", {
                          id: "bio",
                          class: "input input-textarea p-3 w-100",
                          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.formData.influencer_bio) = $event)),
                          style: {"min-height":"150px"}
                        }, null, 512), [
                          [_vModelText, _ctx.formData.influencer_bio]
                        ])
                      ])
                    ])
                  ])),
              (_ctx.successMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(_ctx.successMsg), 1))
                : _createCommentVNode("", true),
              (_ctx.errorMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(_ctx.errorMsg), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["actions-btns", { 'd-none': !_ctx.isAdvertiser }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn",
                  disabled: Object.keys(_ctx.adv_errors).length !== 0,
                  onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)))
                }, " Update profile ", 8, _hoisted_115)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["actions-btns", { 'd-none': _ctx.isAdvertiser }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn",
                  onClick: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)))
                }, " Update profile ")
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'password')
        ? (_openBlock(), _createElementBlock("form", _hoisted_116, [
            (_ctx.submitMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(_ctx.submitMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("div", _hoisted_120, [
                  _hoisted_121,
                  _createElementVNode("div", _hoisted_122, [
                    (!_ctx.showPassword)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                          _withDirectives(_createElementVNode("input", {
                            type: "password",
                            "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.passwordForm.old_password) = $event)),
                            class: _normalizeClass(["pwd-input", { 'invalid-field': _ctx.pwd_errors?.old_password }]),
                            id: "password",
                            onKeyup: _cache[65] || (_cache[65] = ($event: any) => (_ctx.validateInput('old_password'))),
                            onBlur: _cache[66] || (_cache[66] = ($event: any) => (_ctx.validateInput('old_password')))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.passwordForm.old_password,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.pwd_errors?.old_password)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_124, _toDisplayString(_ctx.pwd_errors.old_password), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_125, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.passwordForm.old_password) = $event)),
                            class: _normalizeClass(["pwd-input", { 'invalid-field': _ctx.pwd_errors?.old_password }]),
                            id: "password",
                            onKeyup: _cache[68] || (_cache[68] = ($event: any) => (_ctx.validateInput('old_password'))),
                            onBlur: _cache[69] || (_cache[69] = ($event: any) => (_ctx.validateInput('old_password')))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.passwordForm.old_password,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.pwd_errors?.old_password)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_126, _toDisplayString(_ctx.pwd_errors.old_password), 1))
                            : _createCommentVNode("", true)
                        ])),
                    _createElementVNode("i", {
                      onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword)),
                      role: "button",
                      class: _normalizeClass(["fa-regular icon", {
                  'fa-eye-slash': _ctx.showPassword,
                  'fa-eye': !_ctx.showPassword,
                }])
                    }, null, 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _hoisted_129,
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("div", _hoisted_131, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.passwordForm.new_password) = $event)),
                        class: _normalizeClass(["input password-inp", { 'invalid-field': _ctx.pwd_errors?.new_password }]),
                        id: "new_password",
                        onKeyup: _cache[72] || (_cache[72] = ($event: any) => (_ctx.validateInput('new_password'))),
                        onBlur: _cache[73] || (_cache[73] = ($event: any) => (_ctx.validateInput('new_password')))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.passwordForm.new_password,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.pwd_errors?.new_password)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_132, _toDisplayString(_ctx.pwd_errors.new_password), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_inline_svg, {
                      src: require(`@/assets/images/icons/lock.svg`),
                      class: "icon"
                    }, null, 8, ["src"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                  _hoisted_135,
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("div", _hoisted_137, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.passwordForm.confirmPassword) = $event)),
                        class: _normalizeClass(["input password-inp", { 'invalid-field': _ctx.pwd_errors?.confirm_password }]),
                        id: "confirm_password",
                        onKeyup: _cache[75] || (_cache[75] = ($event: any) => (
                      _ctx.validateConfirmPasswordField(
                        _ctx.passwordForm.new_password,
                        _ctx.passwordForm.confirmPassword
                      )
                      )),
                        onBlur: _cache[76] || (_cache[76] = ($event: any) => (
    _ctx.validateConfirmPasswordField(
      _ctx.passwordForm.new_password,
      _ctx.passwordForm.confirmPassword
    )
    ))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.passwordForm.confirmPassword,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.pwd_errors?.confirm_password)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(_ctx.pwd_errors.confirm_password), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_inline_svg, {
                      src: require(`@/assets/images/icons/lock.svg`),
                      class: "icon"
                    }, null, 8, ["src"])
                  ])
                ])
              ]),
              (_ctx.successMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_139, _toDisplayString(_ctx.successMsg), 1))
                : _createCommentVNode("", true),
              (_ctx.errorMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_140, _toDisplayString(_ctx.errorMsg), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn",
                  disabled: Object.keys(_ctx.pwd_errors).length !== 0,
                  onClick: _cache[77] || (_cache[77] = 
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args)))
                }, " Update Password ", 8, _hoisted_142)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'notifications-preferences')
        ? (_openBlock(), _createElementBlock("form", _hoisted_143, [
            (_ctx.submitMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_144, _toDisplayString(_ctx.submitMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_145, [
              _createElementVNode("div", _hoisted_146, [
                _createElementVNode("div", _hoisted_147, [
                  _hoisted_148,
                  _createElementVNode("label", _hoisted_149, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.allow_notifications) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.allow_notifications]
                    ]),
                    _hoisted_150
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_151, [
                _createElementVNode("div", _hoisted_152, [
                  _hoisted_153,
                  _createElementVNode("label", _hoisted_154, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.allow_emails) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.allow_emails]
                    ]),
                    _hoisted_155
                  ])
                ])
              ]),
              (_ctx.successMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_156, _toDisplayString(_ctx.successMsg), 1))
                : _createCommentVNode("", true),
              (_ctx.errorMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_157, _toDisplayString(_ctx.errorMsg), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_158, [
                _createElementVNode("button", {
                  type: "button",
                  style: {"max-width":"fit-content"},
                  class: "btn",
                  disabled: Object.keys(_ctx.pwd_errors).length !== 0,
                  onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.updateNotificationsPreferences()))
                }, " Update Preferences ", 8, _hoisted_159)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}